import React from "react";
import "./drawer.css";
import CloseIcon from "@mui/icons-material/Close";
const DrawerModel = ({ setMenuAnchorEl }) => {
  const closeMenu = () => {
    console.log("helllo");
    setMenuAnchorEl(false);
  };

  return (
    <div className="fullscreen-menu">
      <CloseIcon
        className="close-button"
        onClick={closeMenu}
        sx={{
          // width:'100px'
          fontSize: "35px",
          // fontWeight:100
          opacity: "0.6",
        }}
      />
      {/* <button >

            </button> */}
      <div className="menu-content">
        <ul
          style={{
            // width:'90%',
            marginTop: "50px",
          }}
        >
          <li>
            <a href="https://affirmate.app/">Home</a>
            <hr className="hr-line" />
          </li>
          <li>
            <a href="https://affirmate.app/#about-us">About</a>
          </li>
          <hr className="hr-line" />
          <li>
            <a href="https://affirmate.app/#faq">FAQ</a>
          </li>
          <hr className="hr-line" />
          <li>
            <a href="https://affirmate.app/#blog">Blog</a>
          </li>
          <hr className="hr-line" />
          <li>
            <a href="https://affirmate.app/#contact-us">Contact Us</a>
            <hr className="hr-line" />
          </li>
          <li>
            <a href="https://affirmate.app/#download-app">Try It for free</a>
            <hr className="hr-line" />
          </li>
          <li>
            <a href="https://affirmate.app/gifts/">Gift Affirmate</a>
            <hr className="hr-line" />
          </li>
          <li>
            <a href="https://affirmate.app/terms/">Terms of Service</a>
            <hr className="hr-line" />
          </li>
          <li>
            <a href="https://affirmate.app/privacy/">Privacy Policy</a>
          </li>
          {/* <hr className="hr-line" /> */}
        </ul>
      </div>
    </div>
  );
};

export default DrawerModel;
